// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QmYm","question":"styles_question__1TGi9","description":"styles_description__3TOV7"};